import { memo, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMenu from 'hooks/useMenu';
import ContractTasksTab from './ContractTasksTab';
import TaskAddModal from './TaskAddModal';

const ContractTasksModal = ({ open, setOpen, contractId, tasks = [], refetchFn }) => {
  const { t } = useTranslation();
  const { hasChild } = useMenu();
  const [addOpen, setAddOpen] = useState(false);

  const canAdd = hasChild('STAFF_TASKS', 'STAFF_ADD_TASKS');

  const handleClose = () => setOpen(false);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
        fullWidth
        PaperProps={{ className: '!base-border !shadow-none' }}
      >
        <DialogTitle className='!bg-gray-100 !mb-2 flex items-center justify-between'>
          <span>
            {t('tasks.staffTask.title')}
            <span className='ml-2 text-sm font-normal text-gray-500'>
              ({tasks.length})
            </span>
          </span>
          <div className='flex items-center gap-2'>
            {canAdd && (
              <Button
                variant='contained'
                color='success'
                size='small'
                startIcon={<i className='bi bi-plus-circle' />}
                onClick={() => setAddOpen(true)}
              >
                {t('tasks.staffTask.addModal.title')}
              </Button>
            )}
            <IconButton size='small' onClick={handleClose}>
              <i className='bi bi-x text-xl' />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <ContractTasksTab tasks={tasks} refetchFn={refetchFn} />
        </DialogContent>
      </Dialog>

      {addOpen && (
        <TaskAddModal
          open={addOpen}
          setOpen={setAddOpen}
          contractId={contractId}
          refetchFn={refetchFn}
        />
      )}
    </>
  );
};

export default memo(ContractTasksModal);
